function PennFill() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_358_70849)">
        <path
          d="M13.498 0.794865L13.647 0.645865C13.7591 0.533782 13.8923 0.444886 14.0388 0.384252C14.1853 0.323618 14.3423 0.292434 14.5009 0.292481C14.6594 0.292527 14.8164 0.323803 14.9629 0.384523C15.1093 0.445242 15.2424 0.534216 15.3545 0.646365C15.4666 0.758514 15.5555 0.891641 15.6161 1.03815C15.6767 1.18465 15.7079 1.34166 15.7079 1.50022C15.7078 1.65877 15.6766 1.81577 15.6158 1.96224C15.5551 2.10871 15.4661 2.24178 15.354 2.35387L15.205 2.50187C15.4599 2.78773 15.5958 3.16026 15.5848 3.54309C15.5738 3.92593 15.4168 4.29007 15.146 4.56087L4.854 14.8539C4.78966 14.9179 4.70911 14.9632 4.621 14.9849L0.620999 15.9849C0.537292 16.0057 0.449615 16.0045 0.366492 15.9815C0.283369 15.9584 0.207627 15.9142 0.14663 15.8532C0.085632 15.7922 0.0414533 15.7165 0.0183878 15.6334C-0.00467757 15.5502 -0.00584496 15.4626 0.0149991 15.3789L1.015 11.3789C1.03688 11.2911 1.08215 11.2109 1.146 11.1469L10.788 1.50487C10.6916 1.437 10.5742 1.40539 10.4568 1.41564C10.3393 1.42589 10.2292 1.47732 10.146 1.56087L6.854 4.85387C6.80751 4.90035 6.75232 4.93723 6.69158 4.96239C6.63084 4.98755 6.56574 5.0005 6.5 5.0005C6.43426 5.0005 6.36915 4.98755 6.30842 4.96239C6.24768 4.93723 6.19249 4.90035 6.146 4.85387C6.09951 4.80738 6.06263 4.75219 6.03748 4.69145C6.01232 4.63071 5.99937 4.56561 5.99937 4.49987C5.99937 4.43412 6.01232 4.36902 6.03748 4.30828C6.06263 4.24754 6.09951 4.19235 6.146 4.14587L9.44 0.853865C9.71097 0.582881 10.0754 0.425886 10.4585 0.415101C10.8415 0.404315 11.2142 0.540557 11.5 0.795865C11.7748 0.550304 12.1303 0.414477 12.4988 0.414293C12.8673 0.414108 13.223 0.549579 13.498 0.794865Z"
          fill="#212529"
        />
      </g>
      <defs>
        <clipPath id="clip0_358_70849">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 -0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PennFill;
